module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    attrs: {
      "mainColumn": "name",
      "longColumn": "remark",
      "resource": _vm.resource,
      "title": "档案查询",
      "label": "区本",
      "labelName": "name",
      "operation": _vm.operation,
      "operationWidth": 113,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "updateList": _vm.updateList,
      "columns": _vm.columns
    }
  }, [_c('SmartDialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "size": _vm.dialogSize
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [(_vm.dialogVisible) ? _c('MapsPage', {
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "markers": _vm.markers,
      "columns": _vm.mapColumns,
      "resource": _vm.mapResource
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a54f6ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Base/Book.vue
// module id = 1708
// module chunks = 1